import React, { ChangeEvent, FunctionComponent } from "react";

import { Caption, CheckBoxComponentValue, GridColumnCount, GridGapSize, GridLayout, GridLayoutItem } from "@multiweb/reactComponents";
import { IAttrValue } from "@multiweb/types/contracts";
import { LOC_CLASS_OBJECTS, LOC_COMMENT, LOC_CONDITION_FOR_OBJECTS, LOC_CONDITION_FOR_WF_MESSAGE, LOC_CONDITION_PARAMETERS, LOC_OUTGOING_MESSAGE_WF, LOC_PROCESS_TO_SAVE_OBJECT } from "../../../../../../locKeys";
import { parseStringToBoolean } from "../../../../../../utils";
import { CONST_ACTION_COMMENT_AT, CONST_ACTION_CONDITION_AT, CONST_SEND_WF_MESSAGE_AFTER_SAVE_AT, CONST_SEND_WF_MESSAGE_MESSAGE_NAME_AT, CONST_SEND_WF_MESSAGE_OBJECTS_CONDITION_AT, CONST_SEND_WF_MESSAGE_OBJECTS_CONDITION_PARAMS_AT, CONST_SEND_WF_MESSAGE_TARGET_OBJECT_NAME_AT } from "../../../../../../workflowParser/constants";
import { Edit, Memo, TextLOVEdit, WfCheckBox } from "../../../../components";
import { MAX_INPUT_LENGTH_L, MAX_INPUT_LENGTH_S, MAX_INPUT_LENGTH_XXL } from "../constants";
import { ActionPageProps } from "../types";

const getTargetObjectNameAttrs = ["Nazev_tridy"];

export const SendWfMessagePage: FunctionComponent<ActionPageProps> = ({ properties, hostKey, updateAction }) => {
    const getTargetObjectName = (results: readonly IAttrValue[] | undefined) => {
        if (results)
            updateAction([{ key: CONST_SEND_WF_MESSAGE_TARGET_OBJECT_NAME_AT, value: results[0].toString() }]);
    };

    const onMessageNameChange = (e: ChangeEvent<HTMLInputElement>) => {
        updateAction([{ key: CONST_SEND_WF_MESSAGE_MESSAGE_NAME_AT, value: e.target.value }]);
    };

    const onConditionChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        updateAction([{ key: CONST_ACTION_CONDITION_AT, value: e.target.value }]);
    };

    const onTargetObjectNameChange = (e: ChangeEvent<HTMLInputElement>) => {
        updateAction([{ key: CONST_SEND_WF_MESSAGE_TARGET_OBJECT_NAME_AT, value: e.target.value }]);
    };

    const onObjectsConditionChange = (e: ChangeEvent<HTMLInputElement>) => {
        updateAction([{ key: CONST_SEND_WF_MESSAGE_OBJECTS_CONDITION_AT, value: e.target.value }]);
    };

    const onObjectsConditionParamsChange = (e: ChangeEvent<HTMLInputElement>) => {
        updateAction([{ key: CONST_SEND_WF_MESSAGE_OBJECTS_CONDITION_PARAMS_AT, value: e.target.value }]);
    };

    const onAfterSaveChange = (value: CheckBoxComponentValue) => {
        updateAction([{ key: CONST_SEND_WF_MESSAGE_AFTER_SAVE_AT, value: value ? "true" : "false" }]);
    };

    const onCommentChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        updateAction([{ key: CONST_ACTION_COMMENT_AT, value: e.target.value }]);
    };

    return (
        <GridLayout columns={GridColumnCount.one} gap={GridGapSize.two}>
            <GridLayoutItem>
                <Caption required locKey={LOC_OUTGOING_MESSAGE_WF} />
                <Edit qa={LOC_OUTGOING_MESSAGE_WF} required maxLength={MAX_INPUT_LENGTH_S} value={properties[CONST_SEND_WF_MESSAGE_MESSAGE_NAME_AT]} onChange={onMessageNameChange} {...{ hostKey }} />
            </GridLayoutItem>
            <GridLayoutItem>
                <Caption locKey={LOC_CLASS_OBJECTS} />
                <TextLOVEdit qa={LOC_CLASS_OBJECTS} value={properties[CONST_SEND_WF_MESSAGE_TARGET_OBJECT_NAME_AT]} formName="FRM.CTrida.CTrida" attributeNames={getTargetObjectNameAttrs} maxLength={MAX_INPUT_LENGTH_L} onChange={onTargetObjectNameChange} onFormClose={getTargetObjectName} {...{ hostKey }} />
            </GridLayoutItem>
            <GridLayoutItem>
                <Caption locKey={LOC_CONDITION_FOR_OBJECTS} />
                <Edit qa={LOC_CONDITION_FOR_OBJECTS} maxLength={MAX_INPUT_LENGTH_XXL} value={properties[CONST_SEND_WF_MESSAGE_OBJECTS_CONDITION_AT]} onChange={onObjectsConditionChange} {...{ hostKey }} />
            </GridLayoutItem>
            <GridLayoutItem>
                <Caption locKey={LOC_CONDITION_PARAMETERS} />
                <Edit qa={LOC_CONDITION_PARAMETERS} maxLength={MAX_INPUT_LENGTH_L} value={properties[CONST_SEND_WF_MESSAGE_OBJECTS_CONDITION_PARAMS_AT]} onChange={onObjectsConditionParamsChange} {...{ hostKey }} />
            </GridLayoutItem>
            <WfCheckBox qa={LOC_PROCESS_TO_SAVE_OBJECT} showFalseAsCrossed textLocKey={LOC_PROCESS_TO_SAVE_OBJECT} value={parseStringToBoolean(properties[CONST_SEND_WF_MESSAGE_AFTER_SAVE_AT], false)} onChange={onAfterSaveChange} {...{ hostKey }} />
            <GridLayoutItem>
                <Caption locKey={LOC_CONDITION_FOR_WF_MESSAGE} />
                <Memo qa={LOC_CONDITION_FOR_WF_MESSAGE} value={properties[CONST_ACTION_CONDITION_AT]} onChange={onConditionChange} {...{ hostKey }} />
            </GridLayoutItem>
            <GridLayoutItem>
                <Caption locKey={LOC_COMMENT} />
                <Memo qa={LOC_COMMENT} value={properties[CONST_ACTION_COMMENT_AT]} onChange={onCommentChange} {...{ hostKey }} />
            </GridLayoutItem>
        </GridLayout>
    );
};
